export const SCREENTAB_VALIDATION_ERROR = 'SCREENTAB_VALIDATION_FAILED';

export type ScreenTabsValidationError = {
	type: typeof SCREENTAB_VALIDATION_ERROR;
	message?: string;
};

type ErrorAttributes = { errors: ScreenTabsValidationError[] };

export class UiModificationsScreenTabsValidationError extends Error {
	attributes: ErrorAttributes;

	constructor(message: string, attributes: ErrorAttributes, cause?: ErrorOptions) {
		super(message, cause);

		this.attributes = attributes;
	}
}
